// atenção: na próxima vez que precisarmos usar HTML perigoso, lembremos de sanitizá-lo para aplicar a sanitização nesses dangerouslySetInnerHTML também
import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import intl from 'react-intl-universal';
import { NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';
import { approveReview, getDocumentReview } from '../../actions/ActionDocumentReview';
import { viewPDF } from '../../actions/ActionDocumentPublish';
import { downloadAttachment, fnDownloadLocalAttachment, fnGetImageAttachment } from '../../actions/ActionDocumentDetails';
import SendDocumentToTrashBin from '../../components/SendDocumentToTrashBin';
import { OptionMenu } from '../../components/OptionMenu';
import Page from '../default-v2/Page';
import { SuggestEdition } from './SuggestEdition';
import Axios from '../../config/Axios';
import ScrollBar from '../../components/ScrollBar';
import './styles/documentreview.scss';
import CardHeader from '../default-v2/CardHeader';
import Attachment from '../document/Attachments';
import 'froala-editor/css/froala_style.min.css';
import '../../assets/scss/froala-custom.scss';
import FroalaEditorComponent from '../../config/FroalaEditorComponent';
import { checkModule, can, hasModule } from '../../config/Permissions';
import DocumentHeader from './DocumentHeader';
import Document from './Document';
import documentImg from '../../assets/img/documents.svg';
import cImageDownload from './img/icon-download.svg';
import PdfFireViewer from '../../components/PdfFireViewer';
//import { TailSpin } from 'react-loader-spinner';
import clipIcon from '../../assets/img/clip.svg';
import { wrappedGetDocument } from './utils/version-access';
import { SuccessModal } from '../../components/molecules/ErrorModal';


class DocumentReview extends Component {
  constructor(oProps) {
    super(oProps);

    const { router } = oProps;
    const params = router ? router.params : {};
    this.state = {
      bLoading: true,
      aAttachments: [],
      nVersionId: params.nVersionId,
      aImgFiles: ['.png', '.jpg', '.jpeg', '.bmp', '.ai', '.eps', '.psd'],
      bIsSending: false,
      bIsModalOpen: false,
      oActiveAttachment: null,
      oActiveAttachmentType: null,
      bShowSpinner: false
    };
  }

  componentDidMount = () => {
    const { router = {} } = this.props;
    checkModule(router.navigate, 'documents');

    this.loadDocument();
  };

  getDocumentHeader = () => {
    return <DocumentHeader bStepEdit bStepReview />;
  };

  viewReviewPDF = evt => {
    evt.preventDefault();
    const { setAlert } = this.props;
    const { nVersionId } = this.state;

    this.setState({ bIsSending: true });

    viewPDF(nVersionId)
      .then(this.setState({ bIsSending: false }))
      .catch(oError => {
        this.setState({ bIsSending: false });
        setAlert('error', oError);
      });
  };

  approve = evt => {
    const { nVersionId } = this.state;
    const { router, setAlert } = this.props;
    const navigate = (router && router.navigate) || (() => { });

    evt.preventDefault();
    this.setState({ bIsSending: true });

    approveReview(nVersionId)
      .then(nVersionApprovedId =>
        navigate(nVersionApprovedId ? `/document/publish/${nVersionApprovedId}` : '/folder', {
          state: { aAlertMessages: { cType: 'success', cMsg: intl.get('DocumentReview.documento_enviado_aprovacao') } }
        })
      )
      .catch(oError => {
        if (oError.response !== undefined && oError.response.status === 406) {
          navigate('/folder_old', {
            state: { aAlertMessages: { cType: 'error', cMsg: oError.aMsgErrors } }
          });
        } else {
          setAlert('error', oError.aMsgErrors || 'erro desconhecido');
        }
      });
  };

  handleChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  loadDocument = async () => {
    const { nVersionId } = this.state;
    const { router, setAlert } = this.props;

    try {
      const oData = await wrappedGetDocument(
        async () => await getDocumentReview(nVersionId),
        { navigate: router?.navigate }
      );
      this.setState({ ...oData });
    } catch (oError) {
      setAlert('error', oError.aMsgErrors);
    }
    this.setState({ bLoading: false });
  };

  openAttachmentImageModal = (oAttachment, fileType, bIsExpanded = false) => {
    const bIsLocal = oAttachment.atch_clocal.startsWith("customer\\");
    fnGetImageAttachment(oAttachment.atch_nid, oAttachment.atch_cname, bIsLocal).then(oData => {
      const bPreviewUnavailable = oData?.cType === 'unavailable';
      let cImageSource = oData.cContent;

      if (oData.cType == "base64") {
        cImageSource = "data:image/png;base64, " + oData.cContent;
      }

      if (oData.cType === 'pdf') {
        const base64Content = oData.cContent;
        cImageSource = `data:application/pdf;base64, ${base64Content}`;
      }

      this.setState({
        rcmpAlert: (
          <SweetAlert
            customClass={`modal-edit modalMedium scrollBar attachment-preview-modal${bIsExpanded ? ' attachment-preview-expanded' : ''}`}
            title=""
            onConfirm={this.hideAlert}
            showConfirm={false}
          >
            <div className="head-modal">
              {intl.get("DocumentEditor.view_attachment")}
              <span
                role="button"
                tabIndex="0"
                aria-labelledby="head-modal"
                onClick={() => (bIsLocal) ?
                  fnDownloadLocalAttachment(oAttachment.atch_nid, oAttachment.atch_cname) : downloadAttachment(oAttachment.atch_nid, oAttachment.atch_cname)}
                className="attachment-download"
                href=""
              ><img src={cImageDownload} /></span>
              <span
                role="button"
                tabIndex="0"
                aria-label={intl.get(bIsExpanded ? 'DocumentEditor.reduce_attachment_viewer' : 'DocumentEditor.expand_attachment_viewer')}
                title={intl.get(bIsExpanded ? 'DocumentEditor.reduce_attachment_viewer' : 'DocumentEditor.expand_attachment_viewer')}
                onKeyDown={(oEvent) => {
                  if (oEvent.key === 'Enter' || oEvent.key === ' ') {
                    oEvent.preventDefault();
                    this.openAttachmentImageModal(oAttachment, fileType, !bIsExpanded);
                  }
                }}
                onClick={() => this.openAttachmentImageModal(oAttachment, fileType, !bIsExpanded)}
                className="attachment-expand"
              >
                <i className={`fa ${bIsExpanded ? 'fa-compress' : 'fa-expand'}`} aria-hidden="true" />
              </span>
              <span
                role="button"
                tabIndex="0"
                aria-labelledby="head-modal"
                onKeyDown={this.handleKeyDown}
                onClick={this.hideAlert}
                className="close"
                href=""
              />
            </div>
            {['png', 'jpg', 'jpeg', 'bmp'].includes(fileType) ? (
              <img className="attachment-image" src={cImageSource} />
            ) : (
              <PdfFireViewer
                pdfBlob={bPreviewUnavailable ? "" : cImageSource}
                canDownload={true}
                nameFile={oAttachment.atch_cname}
                downloadUrl={oData?.cOriginalUrl || ""}
                downloadFileName={oData?.cOriginalFileName || oAttachment.atch_cname}
                fallbackReason={bPreviewUnavailable ? oData?.cReason : null}
                showRetry={bPreviewUnavailable}
                onRetry={() => this.openAttachmentImageModal(oAttachment, fileType, bIsExpanded)}
                cViewerHeight={bIsExpanded ? 'calc(100vh - 180px)' : undefined}
                className="attachment-pdf-viewer"
              />
            )}
          </SweetAlert>
        )
      });
      this.setState({ bShowSpinner: false });
    }).catch(oError => {
      this.setState({ bShowSpinner: false });
    });
  }

  handleDownloadAttachment = (evt, oAttachment) => {
    evt.preventDefault();

    const { setAlert } = this.props; // Extraia setAlert de props
    const attachmentType = oAttachment.atch_cname.split('.').pop().toLowerCase();

    if (['png', 'jpg', 'jpeg', 'bmp', 'pdf', 'docx', 'doc', 'xls', 'xlsx', 'html', 'txt', 'ods'].includes(attachmentType)) {
      // Obtém a URL do anexo e abre o modal
      this.setState({ bShowSpinner: true });
      this.openAttachmentImageModal(oAttachment, attachmentType);
    } else {
      // Download direto para outros tipos de arquivos
      downloadAttachment(oAttachment.atch_nid, oAttachment.atch_cname)
        .catch(oError => setAlert('error', oError));
    }
  };




  openModalRequest = () => {
    const { oRequest } = this.state;

    this.setState({
      rcmpAlert: (
        <SweetAlert
          customClass="modal-edit modal-edit-v2 lg scrollBar"
          title=""
          onConfirm={this.hideAlert}
          showConfirm={false}
        >
          <div className="head-modal">
            {intl.get('suggest_editing')}
            <span
              role="button"
              tabIndex="0"
              aria-labelledby="head-modal"
              onKeyDown={this.handleKeyDown}
              onClick={this.hideAlert}
              className="close"
              href=""
            />
          </div>
          <ScrollBar>
            <SuggestEdition
              onSuccess={cMsg => {
                this.successMessage(cMsg);
              }}
              closeModal={this.hideAlert}
              eType="review"
              nRequestId={oRequest.rqst_nid}
            />
          </ScrollBar>
        </SweetAlert>
      ),
      bIsSending: false
    });
  };

  sendToEditor = () => {
    const { oRequest } = this.state;
    const { setAlert, router } = this.props;
    const navigate = (router && router.navigate) || (() => { });

    const verNid = oRequest?.ver_nid;

    if (!verNid) {
      setAlert('error', 'Não foi possível encontrar o ID da versão (ver_nid).');
      return;
    }

    Axios.post(`/version/reject/${verNid}`, {
      cText: oRequest?.rqst_cjustification || '',
      nRequestId: oRequest?.rqst_nid || ''
    })
      .then(() => {
        navigate(`/document/editor/${verNid}`);
      })
      .catch(oError => {
        if (oError.response !== undefined && oError.response.status === 406) {
          navigate('/folder_old', {
            state: { aAlertMessages: { cType: 'error', cMsg: oError.aMsgErrors } }
          });
        } else {
          this.setState({
            bLoading: false,
            bIsSending: false
          });
          setAlert('error', oError.aMsgErrors);
        }
      });
  };

  changeRequest = evt => {
    evt.preventDefault();
    const { bAmWriter, bAmReviewer } = this.state;
    this.setState({ bIsSending: true });

    if (!bAmReviewer) {
      return;
    }

    if (!bAmWriter) {
      this.openModalRequest(evt);
    } else {
      this.sendToEditor();
    }
  };

  hideAlert = () => {
    this.setState({
      rcmpAlert: null
    });
  };

  successMessage = cMsg => {
    const { router } = this.props;
    const navigate = (router && router.navigate) || (() => { });

    this.hideAlert();

    navigate('/folder_old', {
      state: { aAlertMessages: { cType: 'success', cMsg } }
    });
  };

  handleModalSuccess = async (cMessage) => {
    await this.loadDocument();
    this.hideAlert();

    this.setState({
      rcmpAlert: (
        <SuccessModal onClose={this.hideAlert} message={cMessage} />
      )
    });
  };

  handleModalError = cMessage => {
    this.setState({
      rcmpAlert: (
        <SweetAlert error onConfirm={() => this.hideAlert()}>
          {' '}
          {cMessage}{' '}
        </SweetAlert>
      )
    });
  };

  handleDocumentModal = (evtEditing, fnOnSuccess, fnOnError) => {
    const { nVersionId } = this.state;
    const { router } = this.props;
    this.setState({
      rcmpAlert: (
        <SweetAlert
          customClass="modal-edit modal-edit-v2 lg scrollBar"
          title=""
          onConfirm={this.hideAlert}
          showConfirm={false}
        >
          <div className="head-modal">
            {intl.get('DocumentDetails.editar_documento')}
            <span
              role="button"
              tabIndex="0"
              aria-labelledby="head-modal"
              onKeyDown={this.handleKeyDown}
              onClick={this.hideAlert}
              className="close"
              href=""
            />
          </div>
          <ScrollBar>
            <Document
              router={router}
              bNewDocument={false}
              nVersionId={nVersionId}
              onSuccess={fnOnSuccess}
              onError={fnOnError}
              closeModal={this.hideAlert}
            />
          </ScrollBar>
        </SweetAlert>
      )
    });
  };

  getOptionMenu = () => {
    const { oDocument, oVersion, bAmResponsible } = this.state;
    const cModule = 'documents';

    return (
      oDocument &&
      oVersion && (
        <OptionMenu>
          <li>
            <NavLink title={intl.get('DocumentDetails.interacoes')} to={`/document/interaction/${oVersion.ver_nid}`}>
              <i className="icon-clock" />
              {intl.get('DocumentDetails.interacoes')}
            </NavLink>
          </li>
          {hasModule(cModule) && (bAmResponsible || can('admin', cModule)) && (
            <>
              <li>
                <span
                  role="button"
                  tabIndex="0"
                  onKeyPress={evtKeyPress =>
                    this.handleDocumentModal(evtKeyPress, this.handleModalSuccess, this.handleModalError)
                  }
                  onClick={evtClick =>
                    this.handleDocumentModal(evtClick, this.handleModalSuccess, this.handleModalError)
                  }
                  title={intl.get('DocumentDetails.editar_documento')}
                >
                  <i className="icon-edit" />
                  {intl.get('DocumentDetails.editar_documento')}
                </span>
              </li>
            </>
          )}
          {bAmResponsible && (
            <li>
              <SendDocumentToTrashBin oVersion={oVersion} oDocument={oDocument} />
            </li>
          )}
        </OptionMenu>
      )
    );
  };

  render() {
    const {
      bIsSending,
      bLoading,
      aBreadcrumbFolders,
      rcmpAlert,
      bAmReviewer,
      bAmWriter,
      oVersion,
      oDocument,
      aAttachments,
      bShowSpinner
    } = this.state;

    const { router, getAlert } = this.props;
    const navigate = (router && router.navigate) || (() => { });

    const aBreadCrumbs = [];

    if (aBreadcrumbFolders?.length > 0) {
      aBreadcrumbFolders.forEach(folder => {
        aBreadCrumbs.push({
          name: folder.fldr_cname === 'Documentos' ? intl.get('Nav.document') : folder.fldr_cname,
          path: `/folder_old/${folder.fldr_nid}`,
          bActive: false
        });
      });
    }

    if (oDocument?.doc_ctitle) {
      aBreadCrumbs.push({
        name: oDocument.doc_ctitle,
        path: `/document/detail/${oDocument.doc_nid}`,
        bActive: true
      });
    }

    const rcmpBreadcrumb = aBreadCrumbs;

    return (
      <Page
        loading={bLoading ? 1 : 0}
        rcmpBreadcrumb={rcmpBreadcrumb}
        cTitle={oDocument ? oDocument.doc_ctitle : ''}
        cImage={documentImg}
        rcmpCardHeader={
          <CardHeader rcmpOptionMenu={this.getOptionMenu()} cHtml={this.getDocumentHeader()} />
        }
        cCurrentSideMenuOption={intl.get('Nav.document')}
      >
        {rcmpAlert}
        {bShowSpinner && (
          <div style={{
            position: 'fixed', // Fixa em relação ao viewport
            top: 0,            // Começa no topo do viewport
            left: 0,           // Alinhado à esquerda do viewport
            right: 0,          // Estende até a direita do viewport
            bottom: 0,         // Estende até o fundo do viewport
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Cor de fundo semi-transparente
            display: 'flex',
            justifyContent: 'center', // Centraliza horizontalmente o conteúdo
            alignItems: 'center',     // Centraliza verticalmente o conteúdo
            zIndex: 1000              // Garante que a sobreposição esteja acima de outros elementos
          }}>
            {/* <TailSpin
              type="Puff"
              color="#00BFFF"
              height={100}
              width={100}
            /> */}
          </div>
        )}
        {getAlert()}
        {oVersion && (
          <div className="containerJustification ">
            <h2>{intl.get('justificativa')}</h2>
            <p style={{ whiteSpace: 'pre-wrap' }}>{oVersion.ver_cjustification}</p>
          </div>
        )}

        <form className="form">
          <div className="fr-wrapper">
            <FroalaEditorComponent
              bRevisor={true}
              model={oVersion ? oVersion.ver_ctext : ''}
            />
          </div>

          <div className="attachments-container">
            <div className="attachments-wrapper">
              {aAttachments.length > 0 && (
                <>
                  <span>{intl.get('anexos')}:</span>
                  <ul className="attachments">
                    {aAttachments.map((oAttachment, i) => (
                      <li key={oAttachment.atch_nid}>
                        <a
                          className="download-file-attachment"
                          onClick={evt => this.handleDownloadAttachment(evt, oAttachment)}
                          download
                        >
                          <img
                            className="align clip-icon"
                            src={clipIcon}
                            alt="attachment icon"
                          />
                          <span>{oAttachment.atch_cname}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>

          <div className="button-stack">
            {bAmReviewer && (
              <>
                <Button className="btn alternate back" onClick={() => navigate(-1)} disabled={bIsSending}>
                  {intl.get('cancel')}
                </Button>

                <Button
                  className="btn alternate"
                  type="button"
                  onClick={evt => this.changeRequest(evt)}
                  disabled={bIsSending}
                >
                  {!bAmWriter && intl.get('suggest_editing')}
                  {bAmWriter && intl.get('edit', { cType: '' })}
                </Button>
                <Button
                  disabled={bIsSending}
                  onClick={evt => this.approve(evt)}
                  name="action"
                  value="approve"
                  type="submit"
                  className="btn"
                >
                  {intl.get('aprovar')}
                </Button>
              </>
            )}
          </div>
        </form>
      </Page>
    );
  }
}

export default DocumentReview;
